module.exports = __webpack_public_path__ + "img/logo-dark.cbd487dd.png";